<template>
  <b-card>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingState"
    >
      <b-breadcrumb>
        <b-breadcrumb-item
          :active="stepState == 'zones'"
          @click="stepState = 'zones'"
        >
          Zones List
        </b-breadcrumb-item>
        <b-breadcrumb-item
          v-if="selectedZone"
          :active="stepState == 'services'"
          :disabled="!selectedZone"
          @click="stepState = 'services'"
        >
          Service-Class List
        </b-breadcrumb-item>
      </b-breadcrumb>
      <zones-list
        v-show="stepState == 'zones'"
        @zones-loading-state="loadingState = $event"
        @zone-selected="onZoneSelected"
      />
      <services-list
        v-if="stepState =='services'"
        :selected-zone="selectedZone"
        @services-loading-state="loadingState = $event"
      />
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BOverlay,
  BCard, BBreadcrumb, BBreadcrumbItem,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import ZonesList from '../components/ZoneList.vue'
import ServicesList from '../components/ServicesList.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import tripConfigStore from '../store'

export default {
  components: {
    BOverlay,
    BCard,
    BBreadcrumb,
    BBreadcrumbItem,
    ZonesList,
    ServicesList,
  },
  setup() {
    useRegisterStoreModule('tripConfig', tripConfigStore)
    const loadingState = ref(true)
    const stepState = ref('zones')
    const selectedZone = ref()
    const onZoneSelected = event => {
      if (event) {
        selectedZone.value = event
        stepState.value = 'services'
      }
    }
    watch(stepState, val => {
      if (val === 'zones') {
        selectedZone.value = null
      }
    })
    return {
      stepState,
      selectedZone,
      loadingState,
      onZoneSelected,
    }
  },
}
</script>

<style>

</style>
